/**
 * KLIVLO Steam Gel Nail Remover - page behaviour (prefix glw-).
 *
 * Loaded as type="module" so it can import this theme's own
 * `@shopify/events` and tell the native header cart icon about changes
 * (04-traps.md D8: the theme's cart components only react to a real
 * CartLinesUpdateEvent). A module runs once per URL, so no init guard.
 *
 * Everything money-related comes from Shopify, never from local maths:
 * bundle prices are real variant prices, the drawer is rendered from
 * /cart.js, and line changes go through /cart/change.js.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

var dataEl = document.getElementById('glw-data');
var DATA = dataEl ? JSON.parse(dataEl.textContent) : null;

function formatMoney(cents, format) {
  cents = Math.round(Number(cents) || 0);
  var fmt = format || (DATA && DATA.moneyFormat) || '€{{amount_with_comma_separator}}';
  function delimit(n, precision, thousands, decimal) {
    var fixed = (n / 100).toFixed(precision).split('.');
    var whole = fixed[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (fixed[1] ? decimal + fixed[1] : '');
  }
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
    switch (key) {
      case 'amount': return delimit(cents, 2, ',', '.');
      case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
      case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
      case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
      case 'amount_with_space_separator': return delimit(cents, 2, ' ', ',');
      default: return delimit(cents, 2, ',', '.');
    }
  });
}

function $(sel, root) { return (root || document).querySelector(sel); }
function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

/* ---------------- Gallery ---------------- */

$$('[data-glw-thumb]').forEach(function (thumb) {
  thumb.addEventListener('click', function () {
    var i = thumb.getAttribute('data-glw-thumb');
    $$('[data-glw-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    $$('.glw-stage .glw-slide').forEach(function (img, n) { img.classList.toggle('is-active', String(n) === i); });
  });
});

/* ---------------- Reviews: show 9 more at a time ---------------- */

(function () {
  var more = $('[data-glw-more]');
  if (!more) return;
  var step = Number(more.getAttribute('data-glw-step')) || 9;
  var cards = $$('[data-glw-review]');
  var shown = step;
  function apply() {
    cards.forEach(function (c, i) { c.hidden = i >= shown; });
    more.hidden = shown >= cards.length;
  }
  more.addEventListener('click', function () { shown += step; apply(); });
  apply();
})();

if (DATA) initBuy();

function initBuy() {
  var variants = DATA.variants;
  var byId = {};
  variants.forEach(function (v) { byId[v.id] = v; });

  var state = {
    variant: byId[DATA.defaultVariant] || variants[variants.length - 1],
    qty: 1,
    added: false,
  };

  /* ---------- Buy box state ---------- */

  $$('[data-glw-bundle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = byId[b.getAttribute('data-glw-bundle')];
      if (v) { state.variant = v; render(); }
    });
  });
  $$('[data-glw-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = Number(b.getAttribute('data-glw-qty'));
      state.qty = Math.min(DATA.maxQty, Math.max(1, state.qty + d));
      render();
    });
  });

  function total() { return state.variant.price * state.qty; }

  function render() {
    $$('[data-glw-bundle]').forEach(function (b) {
      var on = Number(b.getAttribute('data-glw-bundle')) === state.variant.id;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    $$('[data-glw-qty-value]').forEach(function (el) { el.textContent = state.qty; });
    var label = state.added ? DATA.text.added : DATA.text.cta + ' · ' + formatMoney(total());
    $$('[data-glw-cta]').forEach(function (el) { el.textContent = label; });
    $$('[data-glw-sticky-cta]').forEach(function (el) {
      el.textContent = state.added ? DATA.text.addedShort : DATA.text.stickyCta;
    });
    $$('[data-glw-sticky-sub]').forEach(function (el) {
      el.textContent = state.variant.title + ' · ' + formatMoney(total());
    });
  }
  render();

  /* ---------- Add to cart ---------- */

  var flashTimer;
  function addToCart() {
    var v = state.variant;
    if (!v || !v.available) return;
    var buttons = $$('[data-glw-add]');
    buttons.forEach(function (b) { b.disabled = true; });

    var deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: v.id, quantity: state.qty }],
      promise: deferred.promise,
    }));

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: state.qty }] }),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'Add to cart failed');
          return body;
        });
      })
      .then(fetchCart)
      .then(function (cart) {
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { didError: false, items: cart.items, source: 'glw-buy-box', itemCount: state.qty },
        });
        resetDeadline();
        state.added = true;
        render();
        clearTimeout(flashTimer);
        flashTimer = setTimeout(function () { state.added = false; render(); }, 1800);
        drawCart(cart);
        openDrawer(true);
      })
      .catch(function (err) {
        console.error('[glw] add to cart failed', err);
        deferred.reject(err);
        alert(err.message || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        buttons.forEach(function (b) { b.disabled = false; });
      });
  }
  $$('[data-glw-add]').forEach(function (b) { b.addEventListener('click', addToCart); });

  /* ---------- Sticky bar (optional "after scroll" mode) ---------- */

  var sticky = $('[data-glw-sticky]');
  var mainCta = $('[data-glw-cta]');
  if (sticky && mainCta && sticky.getAttribute('data-mode') === 'scroll' && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }).observe(mainCta);
  }

  /* ---------- Cart drawer (real cart) ---------- */

  var drawer = $('[data-glw-drawer]');
  if (!drawer) return;
  var linesEl = $('[data-glw-lines]', drawer);
  var lineTpl = $('[data-glw-line-tpl]', drawer);

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function openDrawer(open) {
    drawer.hidden = !open;
    document.documentElement.classList.toggle('glw-lock', open);
    if (open) { tick(); $('[data-glw-close]', drawer).focus({ preventScroll: true }); }
  }

  function drawCart(cart) {
    var has = cart.item_count > 0;
    $$('[data-glw-count]', drawer).forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-glw-when-items]', drawer).forEach(function (el) { el.hidden = !has; });
    $('[data-glw-empty]', drawer).hidden = has;
    $('[data-glw-subtotal]', drawer).textContent = formatMoney(cart.total_price, cart.money_format);

    linesEl.innerHTML = '';
    cart.items.forEach(function (item) {
      var node = lineTpl.content.firstElementChild.cloneNode(true);
      var img = $('img', node);
      if (item.image) {
        img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        img.alt = item.product_title;
      } else {
        img.remove();
      }
      $('[data-f="name"]', node).textContent = item.product_title;
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : '';
      $('[data-f="meta"]', node).textContent = variantTitle + formatMoney(item.final_price) + ' ' + DATA.text.each;
      $('[data-f="qty"]', node).textContent = item.quantity;
      $('[data-f="total"]', node).textContent = formatMoney(item.final_line_price);
      var v = byId[item.variant_id];
      var was = $('[data-f="was"]', node);
      if (v && v.compare > item.final_price) {
        was.textContent = formatMoney(v.compare * item.quantity);
      } else {
        was.remove();
      }
      $$('[data-glw-change]', node).forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.getAttribute('data-glw-change');
          var q = d === 'remove' ? 0 : Math.max(1, item.quantity + Number(d));
          if (q !== item.quantity) changeLine(item.key, q);
        });
      });
      linesEl.appendChild(node);
    });
  }

  function changeLine(key, quantity) {
    drawer.classList.add('is-busy');
    var deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: quantity === 0 ? 'remove' : 'update',
      context: 'cart',
      lines: [{ id: key, quantity: quantity }],
      promise: deferred.promise,
    }));
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false } });
        drawCart(cart);
      })
      .catch(function (err) { deferred.reject(err); console.error('[glw] cart change failed', err); })
      .finally(function () { drawer.classList.remove('is-busy'); });
  }

  $$('[data-glw-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { openDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) openDrawer(false); });

  // On this page the header cart button opens this drawer instead of the
  // theme's own - one cart UI per page, not two. Capture phase so it runs
  // before the theme's delegated on:click handler.
  window.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"], a[href$="/cart"]');
    if (!trigger || drawer.contains(trigger)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetchCart().then(function (cart) { drawCart(cart); openDrawer(true); });
  }, true);

  /* ---------- Reservation countdown (cosmetic) ----------
     Deadline stored as a timestamp, not a decrementing counter, so it
     survives re-renders and page loads. An expired or absurd stored value
     restarts the window instead of freezing on 0:00 (04-traps.md C5). */

  var KEY = 'glw-cart-deadline';
  var WINDOW_MS = DATA.reserveMinutes * 60 * 1000;
  function readDeadline() {
    var until = 0;
    try { until = Number(localStorage.getItem(KEY)); } catch (e) {}
    var now = Date.now();
    if (!until || isNaN(until) || until <= now || until > now + WINDOW_MS) {
      until = resetDeadline();
    }
    return until;
  }
  function resetDeadline() {
    var until = Date.now() + WINDOW_MS;
    try { localStorage.setItem(KEY, String(until)); } catch (e) {}
    return until;
  }
  function tick() {
    var left = Math.max(0, Math.round((readDeadline() - Date.now()) / 1000));
    var label = Math.floor(left / 60) + ':' + String(left % 60).padStart(2, '0');
    $$('[data-glw-timer]', drawer).forEach(function (el) { el.textContent = label; });
  }
  setInterval(function () { if (!drawer.hidden) tick(); }, 1000);
}
